import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { API_endspoints } from "../../API/API_endspoints";
import demoImg from "../../Assets/demo.png";
import AddStateModal from "./AddStateModal";
import React, { useState } from "react";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "1400px",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 3,
  maxHeight: "calc(100vh - 100px)",
  overflow: "scroll",
};

export default function PertnerFoodTruckDetailsModal({
  data,
  open,
  setOpen,
  getDetails,
}) {
  const handleClose = () => setOpen(false);

  // Add state for active image
  const [active, setActive] = useState(0);

  // Add state for selected image and full screen modal
  const [selectedImgIdx, setSelectedImgIdx] = useState(0);
  const [fullScreenOpen, setFullScreenOpen] = useState(false);

  // Prepare images array (max 3, fill with demoImg if needed)
  const images =
    data?.food_truck_image && data.food_truck_image.length > 0
      ? data.food_truck_image.slice(0, 3).map((imgObj) => API_endspoints?.baseURL + imgObj?.image)
      : [];
  while (images.length < 3) images.push(demoImg);

  const dataBoxStyle = {
    background: "#DEE6F252",
    width: "100%",
    height: "Hug(55px)px",
    padding: "14px",
    gap: "10px",
    borderRadius: "12px",
    color: "#164FA1",
    fontWeight: "600",
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{ ...style, width: { xs: "90%", md: "calc(100% - 50px)" }, p: 5 }}
        >
          <Box>
            <Box className="flexBetween">
              <Typography
                sx={{
                  fontWeight: "700",
                  fontSize: { xs: "18px", md: "22px", lg: "26px" },
                  color: "#CC5E02",
                  mb:2,
                }}
              >
                Food Truck Details
              </Typography>
            </Box>

            {/* Main image with blurred background */}
            <Box
              sx={{
                width: "100%",
                height: {
                  xs: "250px",
                  sm: "400px",
                  md: "350px",
                  lg: "450px",
                  xl: "500px",
                },
                position: "relative",
                mb: 2,
                "&::before": {
                  content: '""',
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundImage: `url(${
                    data?.food_truck_image?.length > 0
                      ? API_endspoints.baseURL +
                        data?.food_truck_image[active]?.image
                      : demoImg
                  })`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  filter: "blur(5px)",
                  zIndex: 0,
                  borderRadius: "12px",
                },
              }}
            >
              <img
                src={
                  data?.food_truck_image?.length > 0
                    ? API_endspoints.baseURL +
                      data?.food_truck_image[active]?.image
                    : demoImg
                }
                style={{
                  borderRadius: "12px",
                  position: "relative",
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  zIndex: 1,
                }}
                alt="preview"
              />
            </Box>

            {/* Thumbnails */}
            <Box sx={{ display: "flex", gap: 1, mb: 2,justifyContent:"center" }}>
              {data?.food_truck_image?.length > 1 &&
                data?.food_truck_image?.map((x, i) => (
                  <Box
                    key={i}
                    onClick={() => setActive(i)}
                    sx={{
                      width: "120px",
                      height: "80px",
                      border: i === active ? "2px solid #CC5E02" : "2px solid transparent",
                      borderRadius: "12px",
                      overflow: "hidden",
                      cursor: "pointer",
                    }}
                  >
                    <img
                      src={API_endspoints.baseURL + x.image}
                      alt=""
                      style={{
                        borderRadius: "12px",
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </Box>
                ))}
            </Box>

            {/* Thumbnail list */}
            {/* <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: 2,
                mb: 2,
                flexWrap: "wrap",
              }}
            >
              {images.map((img, idx) => (
                <img
                  key={idx}
                  src={img}
                  alt={`food-truck-thumb-${idx}`}
                  style={{
                    borderRadius: "8px",
                    objectFit: "cover",
                    width: "100px",
                    height: "70px",
                    border: idx === selectedImgIdx ? "2px solid #CC5E02" : "2px solid transparent",
                    cursor: "pointer",
                    boxShadow: idx === selectedImgIdx ? "0 0 8px #CC5E02" : "none",
                  }}
                  onClick={() => setSelectedImgIdx(idx)}
                />
              ))}
            </Box> */}

            {/* Full screen modal for image */}
            {/* <Modal
              open={fullScreenOpen}
              onClose={() => setFullScreenOpen(false)}
              aria-labelledby="full-screen-image"
              aria-describedby="full-screen-image-view"
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100vh",
                  bgcolor: "rgba(0,0,0,0.9)",
                  outline: "none",
                }}
                onClick={() => setFullScreenOpen(false)}
              >
                <img
                  src={images[selectedImgIdx]}
                  alt="food-truck-full"
                  style={{
                    maxWidth: "50vw",
                    maxHeight: "50vh",
                    borderRadius: "15px",
                    boxShadow: "0 0 24px #000",
                  }}
                />
              </Box>
            </Modal> */}

            {/* Responsive image display: show up to 3 images */}
           

            <Box className="flexCenter">
              <Typography
                sx={{
                  fontWeight: "700",
                  fontSize: { xs: "18px" },
                  color: "#164FA1",
                  my: 1,
                }}
              >
                {data?.truck_name}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: { xs: 2, sm: 5 },
                mt: 2,
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  gap: { xs: 2, sm: 5 },
                  flexDirection: { xs: "column", md: "row" },
                }}
              >
                <Box sx={{ width: "100%" }}>
                  <Box py={1} sx={{ fontWeight: "500" }}>
                    Address
                  </Box>
                  <Box
                    sx={{
                      ...dataBoxStyle,
                      height: "160px",
                      overflow: "scroll",
                    }}
                  >
                    <Typography>{data?.address}</Typography>
                  </Box>
                </Box>
                <Box sx={{ width: "100%" }}>
                  <Box py={1} sx={{ fontWeight: "500" }}>
                    State
                  </Box>
                  {data?.state?.length > 0 ? (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                      {data?.state?.map((x, i) => (
                        <Box
                          key={i}
                          sx={{
                            ...dataBoxStyle,
                            width: "fit-content",
                            m: 0.25,
                          }}
                        >
                          <Typography>{x?.state_name}</Typography>
                        </Box>
                      ))}
                    </Box>
                  ) : (
                    <AddStateModal
                      type={2}
                      id={data?.id}
                      getData={getDetails}
                      handleClose1={handleClose}
                    />
                  )}
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                width: "100%",
                display: "flex",
                gap: { xs: 2, sm: 5 },
                flexDirection: { xs: "column", md: "row" },
              }}
            >
              <Box sx={{ width: "100%", mt: 2 }}>
                <Box py={1} sx={{ fontWeight: "500" }}>
                  Type of Meals
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    gap: 1.5,
                    width: "100%",
                    flexWrap: "wrap",
                  }}
                >
                  {data?.meal?.map((x, i) => (
                    <Box key={i} sx={{ ...dataBoxStyle, width: "fit-content" }}>
                      <Typography>{x?.meal_name}</Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
              <Box
                sx={{
                  width: "100%",
                  mt: 2,
                  visibility: data?.diet?.length > 0 ? "visible" : "hidden",
                }}
              >
                <Box py={1} sx={{ fontWeight: "500" }}>
                  Type of Diet
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    gap: 1.5,
                    width: "100%",
                    flexWrap: "wrap",
                  }}
                >
                  {data?.diet?.map((x, i) => (
                    <Box key={i} sx={{ ...dataBoxStyle, width: "fit-content" }}>
                      <Typography>{x?.diet_name}</Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: { xs: 2, sm: 5 },
                mt: 2,
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  gap: { xs: 2, sm: 5 },
                  flexDirection: { xs: "column", md: "row" },
                }}
              >
                <Box sx={{ width: "100%" }}>
                  <Box py={1} sx={{ fontWeight: "500" }}>
                    Description
                  </Box>
                  <Box
                    sx={{
                      ...dataBoxStyle,
                      height: "160px",
                      overflow: "scroll",
                    }}
                  >
                    <Typography>{data?.description}</Typography>
                  </Box>
                </Box>
              </Box>
            </Box>

            <Box className="flexBetween" sx={{ mt: 3 }}>
              <Typography
                sx={{
                  fontWeight: "700",
                  fontSize: { xs: "18px" },
                  // color: theme.palette.text.active,
                  color: "#CC5E02",
                }}
              >
                Additional Questions
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: { xs: 2, sm: 5 },
                mt: 2,
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  gap: { xs: 2, sm: 5 },
                  flexDirection: { xs: "column", md: "row" },
                }}
              >
                <Box sx={{}}>
                  <Box py={1} sx={{ fontWeight: "500" }}>
                    Size of food truck
                  </Box>
                  <Box sx={dataBoxStyle}>
                    <Typography>{data?.size}</Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: { xs: 2, sm: 5 },
                mt: 2,
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  gap: { xs: 2, sm: 5 },
                  flexDirection: { xs: "column", md: "row" },
                }}
              >
                <Box sx={{ width: "100%" }}>
                  <Box py={1} sx={{ fontWeight: "500" }}>
                    The operating mode of the truck
                  </Box>
                  <Box sx={dataBoxStyle}>
                    <Typography>{data?.operating_mode}</Typography>
                  </Box>
                </Box>

                <Box sx={{ width: "100%" }}>
                  <Box py={1} sx={{ fontWeight: "500" }}>
                    Is a water connection required?
                  </Box>
                  <Box sx={dataBoxStyle}>
                    <Typography>
                      {data?.is_water_required ? "Yes" : "No"}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>

            <Box sx={{ width: "100%", mt: 2 }}>
              <Box py={1} sx={{ fontWeight: "500" }}>
                Equipment required on site
              </Box>
              <Box
                sx={{
                  display: "flex",
                  gap: 1.5,
                  width: "100%",
                  flexWrap: "wrap",
                }}
              >
                {data?.requirement?.map((x, i) => (
                  <Box key={i} sx={{ ...dataBoxStyle, width: "fit-content" }}>
                    <Typography>{x?.requirement}</Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}
